import { render, staticRenderFns } from "./AmChart.vue?vue&type=template&id=ba187a04"
import script from "./AmChart.vue?vue&type=script&lang=js"
export * from "./AmChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports